import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import HubSpotUserSelect from './HubSpotUserSelect';
import { jsx as _jsx } from "react/jsx-runtime";
const tooltip = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "editLink.tooltip.organizer"
});
const EditOwnedBy = ({
  editingLinkOwnerUserId,
  isNewLink,
  handleOwnedByChange,
  setSelectedUserOption,
  validationMessage,
  canEditAllLinks,
  help
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editLink.meetingOrganizer"
    }),
    tooltip: tooltip,
    error: !!validationMessage,
    validationMessage: validationMessage,
    help: help,
    children: /*#__PURE__*/_jsx(HubSpotUserSelect, {
      "data-test-id": "owner-select",
      disabled: !isNewLink || !canEditAllLinks,
      value: editingLinkOwnerUserId,
      onChange: value => {
        setSelectedUserOption(value);
        handleOwnedByChange(value);
      },
      error: undefined,
      valueComponent: undefined
    })
  });
};
export default EditOwnedBy;